// @ts-check
import React, { useMemo } from "react"
import { flexRender } from "@tanstack/react-table"
import { buildPinnedTableStyle } from "../utils/TableLayout.utils"

/**
 * @param {import("./TableFootCell.component.types").TableFootCellProps} props
 */
export const TableFootCell = (props) => {
  const { header } = props

  /** @type {import("../types/table").ExpandedColumnMeta | undefined} */
  const columnMeta = header.column.columnDef.meta

  const className = `table__cell table__cell--foot ${columnMeta?.className ?? ""}`

  const pinnedStyle = useMemo(
    () => buildPinnedTableStyle(header.column),
    [header.column]
  )

  return (
    <td
      className={className}
      onClick={header.column.getToggleSortingHandler()}
      style={{ ...pinnedStyle }}
    >
      {header.isPlaceholder ? null : (
        flexRender(header.column.columnDef.footer, header.getContext())
      )}
    </td>
  )
}
